import type { Invoice } from "@nlc/shared-types";

import {
  DownloadIcon,
  EllipsisVerticalIcon,
  EyeIcon,
  LinkIcon,
} from "lucide-react";

import { AccessibleIcon } from "@/components/accessible-icon";
import { Button } from "@/components/button";
import { Menu, MenuItem, MenuItemLabel, MenuTrigger } from "@/components/menu";
import { Popover } from "@/components/popover";

interface InvoiceActionsProps {
  invoice: Invoice;
  onCopyLink: (invoice: Invoice) => void;
}

export function InvoiceActions({ invoice, onCopyLink }: InvoiceActionsProps) {
  return (
    <div className="flex items-center gap-xs">
      <Button
        aria-label={`View invoice ${invoice.id}`}
        color="gray"
        isIconOnly
        size="sm"
        variant="tertiary"
      >
        <EyeIcon size={18} />
      </Button>

      <MenuTrigger>
        <Button
          aria-label={`Actions for invoice ${invoice.id}`}
          color="gray"
          isIconOnly
          size="sm"
          variant="tertiary"
        >
          <EllipsisVerticalIcon size={18} />
        </Button>

        <Popover placement="bottom end">
          <Menu className="w-[160px]">
            <MenuItem onAction={() => onCopyLink(invoice)}>
              <AccessibleIcon>
                <LinkIcon />
              </AccessibleIcon>
              <MenuItemLabel>Copy link</MenuItemLabel>
            </MenuItem>

            <MenuItem>
              <AccessibleIcon>
                <DownloadIcon />
              </AccessibleIcon>
              <MenuItemLabel>Download</MenuItemLabel>
            </MenuItem>
          </Menu>
        </Popover>
      </MenuTrigger>
    </div>
  );
}
